import axios from 'axios';
import { useAuthStore } from '../stores/t-auth';

const instance = axios.create({
    //baseURL: import.meta.env.VITE_API_ENDPOINT,
    headers: {
        Accept: 'application/json',
        //   Authorization: 'Bearer ' + glob.token
    },
    baseURL: "/api/alerce/1.0.0"
});
instance.interceptors.response.use(
    response => response,
    async error => {
        const auth = useAuthStore();
        if (error.response && error.response.status === 401) {
            // Handle 401 Unauthorized
            console.log('Unauthorized, refreshToken...');
            auth.refreshToken();
        }
        return Promise.reject(error);
    }
);
export { instance }